import React from 'react';
import styled, { css } from 'styled-components';
import { bool, func, string } from 'prop-types';
import {
  Button,
  Flex,
  Typography,
  Input,
  Icon,
  Loader,
} from '@atoms';
import { ErrorToast } from '@molecules';
import { ReactComponent as MadisonsLogo } from '@assets/madisons-logo.svg';

import { handleEnterKeyPress } from '@helpers/common';

const Login = ({
  isLoading,
  error,
  password,
  onToastClose,
  onPasswordChange,
  onLoginSubmit,
  hasServerError,
}) => (
  <>
    <Wrapper column>
      <Flex grow={0} justifyCenter padding="xl6">
        <Icon SVG={MadisonsLogo} height="20px" width="154px" />
      </Flex>
      <Flex grow={0} padding="xl3">
        <Flex column itemsCenter>
          <Typography size="xl4" weight="black">
            Welcome back!
            <br />
            Please sign in to begin
          </Typography>
          {!!error && (
            <Flex paddingTop="md">
              <Typography color="strawberry" size="lg" weight="bold">
                {error}
              </Typography>
            </Flex>
          )}
          <Input
            marginTop="xl2"
            marginBottom="xl2"
            type="password"
            id="password"
            name="password"
            placeholder="Password"
            value={password}
            isError={!!error}
            onChange={onPasswordChange}
            onKeyPress={handleEnterKeyPress(onLoginSubmit)}
            data-cy="password"
          />
          <Button.Rectangular
            disabled={!password.length}
            primary
            gradient
            fullWidth
            padding="xl2"
            marginBottom="xl2"
            onClick={onLoginSubmit}
            data-cy="signIn"
          >
            Sign in
          </Button.Rectangular>
        </Flex>
      </Flex>
    </Wrapper>
    {isLoading && <Loader />}
    {hasServerError && <ErrorToast onToastClose={onToastClose} />}
  </>
);

const Wrapper = styled(Flex)`
  ${() => css`
    position: relative;
    min-height: calc(100% - 108.4px);
    margin-bottom: 108.4px;
    text-align: center;
  `}
`;

Login.propTypes = {
  onToastClose: func.isRequired,
  hasServerError: bool.isRequired,
  isLoading: bool.isRequired,
  error: string.isRequired,
  password: string.isRequired,
  onPasswordChange: func.isRequired,
  onLoginSubmit: func.isRequired,
};

export default Login;
